import React, { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import { BreOrderType } from '~/tenants/bre/model/enums';
import BreCopyrightDisclosure from '~/tenants/bre/performable/BreCopyrightDisclosure';
import BreSocialAddOns from '~/tenants/bre/performable/social/BreSocialAddOns';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';
import { useIsPerformableGroup } from '~/components/performable/PerformableGroupForm';
import BreAerialAddOn from '~/tenants/bre/performable/BreAerialAddOn';
import BreBoostAddOn from '~/tenants/bre/performable/BreBoostAddOn';

export default function BreSocialForm({ context, persona }: TenantPerformableFormProps<BreOrderContext>): ReactElement {
  const grouped = useIsPerformableGroup();

  return (
    <FormGroup>
      {persona === PersonaType.OFFICE && (
        <FormHorizontal label="Self Edited">
          <ZodFieldCheckbox name="self_edited" />
        </FormHorizontal>
      )}

      <TenantPerformableAddOns persona={persona}>
        <BreSocialAddOns persona={persona} />

        {grouped && (
          <>
            <BreBoostAddOn persona={persona} />
            <BreAerialAddOn persona={persona} />
          </>
        )}
      </TenantPerformableAddOns>

      {context.metadata.type === BreOrderType.RENTAL && <BreCopyrightDisclosure context={context} />}
    </FormGroup>
  );
}
